/**
 * Public playlist for the kiosk attract-mode video loop (BluppiTV
 * integration — see CLAUDE.md "Attract-mode video loop").
 */
export const fetchKioskLoopVideos = async () => {
  const response = await fetch('/api/kiosk-loop-videos');
  const contentType = response.headers.get('content-type') || '';

  if (!contentType.includes('application/json')) {
    throw new Error('La API del video loop devolvió una respuesta inesperada');
  }

  const data = await response.json();
  if (!response.ok) {
    throw new Error(data?.error || `Error ${response.status} al cargar el video loop`);
  }
  return Array.isArray(data) ? data : [];
};
